import { useSignals } from '@preact/signals-react/runtime';
import { Form } from 'antd';
import Modal from 'components/Modal';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import SelectColorByConfigStatus from './SelectColorByConfigStatus';
import appointmentActions from 'features/appointment/services/actions';
import { useAppDispatch } from 'store/hooks';

export type IModalChangeColorAptRef = {
  open: (appointmentId: string, currentColor?: string) => void;
};

type FormType = {
  color: string;
  appointmentId: string;
  currentColor: string;
};
export const modalChangeColorAptRef = React.createRef<IModalChangeColorAptRef>();
const ModalChangeColorApt = forwardRef<IModalChangeColorAptRef, {}>((props, ref) => {
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const handleOpen = (appointmentId: string, currentColor?: string) => {
    setVisible(true);
    form.setFieldsValue({
      appointmentId,
      currentColor,
    });
  };

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  const handleCancel = () => {
    setVisible(false);
  };

  const handleSubmit = async (values: FormType) => {
    dispatch(appointmentActions.updateColorAppointment({ appointmentId: values.appointmentId, color: values.color }));
    setVisible(false);
  };

  const handleSelectColor = () => {
    form.submit();
    setVisible(false);
  };


  return (
    <Modal
      modalTitle='color customization'
      width={'80vw'}
      visible={visible}
      onClose={handleCancel}
      hiddenOkButton
      onSubmit={form.submit}
      noneBodyStyle
      closable={false}
      footerPadding={0.5}
      destroyOnClose
      v2
    >
      <Form
        form={form}
        initialValues={{}}
        onFinish={handleSubmit}
      >
        <Form.Item name='currentColor' noStyle />
        <Form.Item name='appointmentId' noStyle />
        <Form.Item name='color' noStyle>
          <SelectColorByConfigStatus onSelectColor={handleSelectColor} />
        </Form.Item>
      </Form>
    </Modal>
  );
});

ModalChangeColorApt.displayName = 'ModalChangeColorApt';
export default ModalChangeColorApt;
